const VIDEO_MODAL_SELECTOR = '.video-modal';
const VIDEO_MODAL_TRIGGER_SELECTOR = '[data-fancybox][data-src^="#"]';

const getVideoModal = (instance) => {
    if (!instance || !instance.current || !instance.current.src) {
        return null;
    }

    let target = null;

    try {
        target = document.querySelector(instance.current.src);
    } catch (error) {
        return null;
    }

    if (!target || !target.matches(VIDEO_MODAL_SELECTOR)) {
        return null;
    }

    return target;
};

const resetVideo = (modal) => {
    const video = modal ? modal.querySelector('.video-modal__video') : null;

    if (!video) {
        return;
    }

    video.pause();
    video.currentTime = 0;
};

const playVideo = (modal) => {
    const video = modal ? modal.querySelector('.video-modal__video') : null;

    if (!video) {
        return;
    }

    video.muted = true;
    video.setAttribute('muted', '');

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
    }
};

const setVideoModalClass = (instance) => {
    if (instance && instance.$refs && instance.$refs.container) {
        instance.$refs.container.addClass('video-modal-fancybox');
    }
};

const removeVideoModalClass = (instance) => {
    if (instance && instance.$refs && instance.$refs.container) {
        instance.$refs.container.removeClass('video-modal-fancybox');
    }
};

const videoModalOptions = {
    smallBtn: false,
    buttons: ['close']
};

const openVideoModal = (modal) => {
    if (!modal || !modal.id || !window.$ || !window.$.fancybox) {
        return;
    }

    window.$.fancybox.open({
        src: `#${modal.id}`,
        type: 'inline',
        opts: videoModalOptions
    });
};

const initVideoModals = () => {
    const modals = document.querySelectorAll(VIDEO_MODAL_SELECTOR);

    if (!modals.length || !window.$ || !window.$.fancybox) {
        return;
    }

    window.$(document).on('afterShow.fb', (event, instance) => {
        const modal = getVideoModal(instance);

        if (!modal) {
            return;
        }

        setVideoModalClass(instance);
        playVideo(modal);
    });

    window.$(document).on('afterClose.fb', (event, instance) => {
        const modal = getVideoModal(instance);

        if (!modal) {
            return;
        }

        resetVideo(modal);
        removeVideoModalClass(instance);
    });

    modals.forEach((modal) => {
        const video = modal.querySelector('.video-modal__video');

        if (video) {
            video.addEventListener('ended', () => {
                window.$.fancybox.close();
            });
        }

        openVideoModal(modal);
    });

    window.$(VIDEO_MODAL_TRIGGER_SELECTOR).filter((index, trigger) => {
        let target = null;

        try {
            target = document.querySelector(trigger.dataset.src);
        } catch (error) {
            return false;
        }

        return target && target.matches(VIDEO_MODAL_SELECTOR);
    }).fancybox(videoModalOptions);
};

document.addEventListener('DOMContentLoaded', initVideoModals);
